import { render, staticRenderFns } from "./MaquinaInstancia.vue?vue&type=template&id=16663f88&scoped=true&"
import script from "./MaquinaInstancia.vue?vue&type=script&lang=js&"
export * from "./MaquinaInstancia.vue?vue&type=script&lang=js&"
import style0 from "./MaquinaInstancia.vue?vue&type=style&index=0&id=16663f88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16663f88",
  null
  
)

export default component.exports